import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71abe928"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "articles" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_4 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_blog_table_actions = _resolveComponent("blog-table-actions")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Статьи" }),
      _createVNode(_component_router_link, { to: "/blog/create" }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "primary small" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" Добавить статью ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка статей произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadArticles(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.ArticlesColumns,
                rows: _ctx.state.list,
                pagination: "",
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-limit": _ctx.state.pagination.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadArticles
              }, {
                actions: _withCtx(({ row }) => [
                  _createVNode(_component_blog_table_actions, {
                    article: row,
                    onDeleted: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadArticles(_ctx.state.pagination.current_page)))
                  }, null, 8, ["article"])
                ]),
                td: _withCtx(({ row, column }) => [
                  (column.key === 'created_at')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(row[column.key])), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}